import { GetterTree } from 'vuex'
import { CookieState, CookieCategoryItemKey } from './types'
import { RootState } from '../types'

export const getters: GetterTree<CookieState, RootState> = {
  getCategoriesId: (state: CookieState) => {
    if (state.categories) { Object.keys(state.categories) }
  },
  getCategory: (state: CookieState) =>
    (key: CookieCategoryItemKey) => {
      if (state.categories) { return state.categories[key] }
    }
}
